<div class="full-page-wrapper">
  <ng-content></ng-content>
</div>